<script setup lang="ts">
defineProps<{
  content: string
  position?: 'top' | 'bottom' | 'left' | 'right'
}>()
</script>

<template>
  <span
    v-tooltip="{
      value: content,
      position: position ?? 'top',
      showDelay: 200,
      event: 'both',
      pt: { root: 'app-tooltip' },
    }"
    class="tooltip-wrapper"
  >
    <slot />
  </span>
</template>

<style scoped>
.tooltip-wrapper {
  display: inline-flex;
}
</style>
